var _ = require('optimizely-client-fn');
var Constants = require('../constants');
var KeyPath = require('core/utils/key_path');
var Logger = require('core/utils/logger');

module.exports = {
  fieldsNeeded: function (condition) {
    return [identifyNeededScore(condition)];
  },

  /**
   * @param {Object} profile
   *        The current visitor profile.
   * @param {Condition} condition
   *        An audience condition of type `predicted_intent`.
   * @returns {boolean|undefined}
   *        Undefined when the audience condition lacks a value (a score cutoff).
   *        True iff the score that the given condition calls for is at least as
   *        great as the condition's score cutoff.
   *        False iff the aforementioned comparison came out false.
   */
  match: function (profile:any, condition:Condition): boolean|undefined {
    var scoreCutoff = condition.value;

    if (_.isNull(scoreCutoff) || _.isUndefined(scoreCutoff)) {
      // There are two known reasons a score cutoff may not be present in a condition:
      //   1) the InterestGroup is not yet `available`.
      //   2) some services.exceptions.Error occured during condition formatting, and an error
      //      message was stashed in the condition's `name`.
      // If the reason had been (2), then `match` will never have been invoked and the
      // error messages will have surfaced on this line:
      // https://github.com/optimizely/client-js/blob/e4c43b48dc0b160f5b27a23dac0dbfba96f721ae/src/core/audience/index.js#L98
      // That leaves (1), where `match` has been called because the visitor has a score for
      // the relevant InterestGroup, but the condition itself lacks a cutoff.
      Logger.debug('Condition has no score cutoff. Is the InterestGroup `available` yet?');
      return;
    }

    var scoreKeyPath = identifyNeededScore(condition);
    var score = KeyPath.getFieldValue(profile, scoreKeyPath);

    return score >= scoreCutoff;
  },
};

/**
 * @param {Condition} condition
 * @returns {KeyPath}
 *        Visitor profile path to the InterestGroup score needed to evaluate the
 *        given condition.
 * @private
 */
function identifyNeededScore(condition:Condition): KeyPath {
  var interestGroupId = condition.name;
  return [Constants.INTEREST_GROUPS_PROFILE_PREFIX, interestGroupId, 'score'];
}

